<template>
  <div>
    <p class="text-xs font-bold">
      {{ rule.name }}:
    </p>
    <component class="mb-4" :is="rule.component" v-model="rule.value" @input="$emit('input', $event)" :rule="rule" v-if="rule.active"></component>
    <div v-for="(child, j) in rule.children" :key="'filter-children-components-' + j">
      <filter-rules :rule="child" @input="$emit('input', $event)" v-if="rule.active && child.active" v-show="showChild(child)"></filter-rules>
    </div>
  </div>
</template>

<script>
const FilterRules = resolve => require(['@/components/filters/Rules'], resolve)
const FilterSelect = resolve => require(['@/components/filters/Select'], resolve)
const FilterFlatpickr = resolve => require(['@/components/filters/Flatpickr'], resolve)
const FilterModelSelect = resolve => require(['@/components/filters/FilterModelSelect'], resolve)

export default {
  name: 'filter-rules',
  props: {
    rule: {}
  },
  components: {
    FilterRules,
    FilterSelect,
    FilterFlatpickr,
    FilterModelSelect,
  },
  methods: {
    showChild(child) {
      let parentValue = this.rule.value
      if (this.rule.value && this.rule.value.constructor === Object) {
        parentValue = Object.entries(this.rule.value).length
      }
      return !!parentValue === child.showWhenParentValue
    }
  }
}
</script>

